import { EditableContent } from '../../../edit/EditableContent';
import type { BlockRenderProps } from '../../../types';
import { isMenuItemActive } from '../menuEditHelpers';
import { readHighlightMenuSection } from './highlightMenuItems';

/** Chalkboard board — lunch / happy hour story energy (typography only; no dietary chips). */
export function MenuHighlightChalkboard({
  block,
  locale,
  isActive,
  activeEditTarget,
  editable,
}: BlockRenderProps) {
  const { sectionTitle, sectionSubtitle, dishes } = readHighlightMenuSection(
    block,
    locale,
  );
  const target = isActive ? activeEditTarget : null;

  return (
    <section
      className={['ws-hl-chalk', isActive ? 'ws-block--active' : ''].filter(Boolean).join(' ')}
      data-block-id={block.blockId}
      data-component={block.componentType}
      data-registry-key={block.registryBlockKey}
      id="menu"
    >
      <div className="ws-hl-chalk__board">
        <header className="ws-hl-chalk__intro">
          <EditableContent
            as="h2"
            fieldKey="sectionTitle"
            editable={editable}
            activeEditTarget={target}
            className="ws-hl-chalk__title"
          >
            {sectionTitle}
          </EditableContent>
          {sectionSubtitle || editable ? (
            <EditableContent
              as="p"
              fieldKey="sectionSubtitle"
              editable={editable}
              activeEditTarget={target}
              className="ws-hl-chalk__subtitle"
            >
              {sectionSubtitle}
            </EditableContent>
          ) : null}
        </header>
        <ul className="ws-hl-chalk__list">
          {dishes.map(({ item, columnIndex, itemIndex }) => (
            <li
              key={`${columnIndex}-${itemIndex}`}
              className={[
                'ws-hl-chalk__row',
                isMenuItemActive(
                  target?.kind === 'menu-item' ? target : null,
                  columnIndex,
                  itemIndex,
                )
                  ? 'ws-edit-child--active'
                  : '',
              ]
                .filter(Boolean)
                .join(' ')}
              {...(editable
                ? {
                    'data-edit-child': 'menu-item' as const,
                    'data-column-index': columnIndex,
                    'data-item-index': itemIndex,
                  }
                : {})}
            >
              <span className="ws-hl-chalk__name">{item.name}</span>
              {item.description ? (
                <p className="ws-hl-chalk__desc">{item.description}</p>
              ) : null}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
